






import { NotificationLevel } from '@/components/molecules/notification-section/model/notification-section-model'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class NotificationSectionWrapper extends Vue {
  @Prop({ required: true })
  readonly level: NotificationLevel

  get classNameForLevel(): string {
    return `c-notification--${this.level}`
  }
}
